var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.contextualLoading)?_c('div',{staticClass:"flex-centerize"},[_c('SkippedContextualNodeBtn',{staticClass:"flex-centerize",attrs:{"placement":_vm.elementPlacement},on:{"onClick":_vm.createActionContextNode}})],1):_c('AppLoader')
}
var staticRenderFns = []

export { render, staticRenderFns }